<ng-container *ngIf="(currentTabletMessage$ | async) as tabletMessage; else empty">
    <iframe
        *ngIf="tabletMessage.signableForm?.signedAt === null && tabletMessage.signableForm?.signableFormUrl; else empty"
        class="form-frame"
        type="text/html"
        [src]="tabletMessage.signableForm?.signableFormUrl | safe"
    ></iframe>
</ng-container>

<ng-template #empty>
    <div class="form-frame centered">
        <img class="logo" alt="Queens casino logo" priority ngSrc="images/queens-casino.svg" width="200" height="100">
    </div>
</ng-template>
